import React, { useRef, useState, useEffect, useContext } from 'react';
import classNames from './Headerv2.module.scss';
import { FaBell } from 'react-icons/fa6';
import { DropdownNotification } from 'components/organisms/DropdownNotification/DropdownNotification';
import { Link, useNavigate } from 'react-router-dom';
import { MemberPortalConfigContext } from 'contexts/MemberPortalConfigContext';

const defaultNotificationsNumber = 3;
const HeaderNotificationsDropdown = (): any => {
    const { memberNotifications, markAsReadMemberNotifications } =
        useContext(MemberPortalConfigContext);
        const {dropdownNotifications} = memberNotifications;
    const [isMyInfoOpen, setIsMyInfoOpen] = useState(false);
    const navigate = useNavigate();
    const dropdownElementRef = useRef<HTMLDivElement>(null);
    const handleClickOnMyInfo = () => {
        if (dropdownNotifications.length == 0) {
            navigate('/notifications');
        } else {
            if (isMyInfoOpen) {
                markAsReadMemberNotifications(defaultNotificationsNumber);
            }
            setIsMyInfoOpen((currentIsMyInfoOpen) => !currentIsMyInfoOpen);
        }
    };

    const handleClickAway = (event: MouseEvent) => {
        if (
            dropdownElementRef?.current &&
            !dropdownElementRef?.current.contains(event.target as Node)
        ) {
            markAsReadMemberNotifications(defaultNotificationsNumber);
            setIsMyInfoOpen(false);
        }
    };

    useEffect(() => {
        if (isMyInfoOpen) {
            document.addEventListener('click', handleClickAway);
        }
        return () => {
            document.removeEventListener('click', handleClickAway);
        };
    }, [isMyInfoOpen]);

    return (
        <div
            aria-label="button"
            className={`d-flex flex-column justify-content-center align-items-center ${
                classNames['header-item']
            } ${classNames.clickable} ${isMyInfoOpen ? classNames.open : ''}`}
            onClick={handleClickOnMyInfo}
        >
            <div>
                <FaBell color="white" size={40} />
                {dropdownNotifications.length > 0 && (
                    <span
                        className={`${classNames['notifications-count-container']} ${isMyInfoOpen ? classNames['notification-counter-open']: ''}`}
                        style={{ fontSize: dropdownNotifications.length > 9 ? 20 : 25 }}
                    >
                        {dropdownNotifications.length}
                    </span>
                )}
            </div>
            <span>Notifications</span>

            {isMyInfoOpen && (
                <div className={classNames['dropdown']} ref={dropdownElementRef}>
                    <div className={classNames['notifications-dropdown-container']}>
                        <div className={classNames['notifications-header']}>
                            <span> NOTIFICATIONS </span>{' '}
                        </div>
                        {dropdownNotifications.slice(0, defaultNotificationsNumber).map((notification, i) => (
                            <DropdownNotification
                                key={'notification' + i}
                                notification={notification}
                            />
                        ))}
                        {dropdownNotifications.length > defaultNotificationsNumber && (
                            <Link to="/notifications">
                                <div className={classNames['notifications-footer']}>
                                    <span> View All </span>{' '}
                                </div>{' '}
                            </Link>
                        )}
                    </div>
                </div>
            )}
        </div> 
    );
};

export default HeaderNotificationsDropdown;
